import React from 'react';

function SimpleTooltip(props) {
  const [show, setShow] = React.useState(false);
  
  return (
    <div 
      style={{ display: 'inline-block', position: 'relative' }}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {props.children}
      
      {show && (
        <div style={{
          position: 'absolute',
          bottom: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'black',
          color: 'white',
          padding: '12px',
          borderRadius: '4px',
          fontSize: '14px',
          whiteSpace: 'nowrap',
          zIndex: 1000,
          marginBottom: '8px',
          border: '1px solid #272727'	
        }}>
          {props.content}
          <div style={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            border: '4px solid transparent',
            borderTopColor: 'black'
          }} />
        </div>
      )}
    </div>
  );
}

export default SimpleTooltip; 